import React, { useState } from 'react';
import { Skeleton } from 'antd';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';

import { IRegion, useGetRegions } from 'modules/global';

const LeftSideSecondSection = () => {
  const t = useTranslations();

  const { regions, isLoading: regionsLoading } = useGetRegions();
  const [query, setQuery] = useQueryParams({
    address_id: withDefault(NumberParam, 0),
    page: NumberParam
  });

  const [activeValue, setActiveValue] = useState<number>(query.address_id ?? 0);

  const handleRegionClick = (region: IRegion) => {
    setActiveValue(region.value);

    setQuery({
      address_id: region.value === 0 ? undefined : region.value,
      page: undefined
    });
  };

  return (
    <div className="rounded-2xl bg-white p-3 shadow-sm sm:col-span-1">
      <h2 className="text-xs text-gray-400">{t('regionlar')}</h2>
      <div className="mt-3">
        {regionsLoading ? (
          <div className="mt-4 space-y-3">
            {Array.from({ length: 5 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton.Button key={index} active className="!h-10 !w-full" />
            ))}
          </div>
        ) : (
          <div className="mt-2">
            <ul className=''>
              {regions?.map(item => {
                const isActive = activeValue === item.value;

                return (
                  <li
                    key={item?.value}
                    className={classNames("py-2 pl-2 cursor-pointer !items-center rounded-md text-sm text-light my-1", {
                      "border-r-3 border-green-500 bg-green-50": isActive,
                      "transparent": isActive
                    })}
                    onClick={() => handleRegionClick(item)}
                  >
                    <span className={`${isActive ? 'font-medium text-green-500' : 'font-normal text-black'}`}>
                      {item.label}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeftSideSecondSection;
